module.exports = __webpack_public_path__ + "static/media/iris_dataset.1e58803b.png";